const colors =
  `#556b2f,#a0522d,#483d8b,#008000,#008b8b,#9acd32,#00008b,#7f007f,#8fbc8f,#b03060,#ff4500,#ff8c00,#ffd700,#7cfc00,#8a2be2,#00ff7f,#dc143c,#00ffff,#00bfff,#f4a460,#0000ff,#b0c4de,#ff00ff,#1e90ff,#90ee90,#ff1493,#ee82ee,#ffe4b5,#ffb6c1`.split(
    ',',
  );
const components = {};
const cr = () => Math.random() * (255 - 1) + 1;
const showRenderStats = () => {
  const componentsMap = Object.keys(components)
    .map((key) => ({ ...components[key], name: key }))
    .sort((comp1, comp2) => (comp1.i > comp2 ? 1 : comp1 === comp2 ? 0 : -1));
  componentsMap.forEach((comp) => {
    console.log(`%c render_d ${comp.name} ${comp.i}`, `color:white;background:${comp.color};`);
  });
};
const stopLogs = true;
declare global {
  interface Window {
    google: any;
    renderDebug: any;
  }
}
if (process.env.NODE_ENV === 'development' && !stopLogs) {
  window.renderDebug = { components, showRenderStats };
}
export const dLog = (componentName) => {
  if (process.env.NODE_ENV === 'development' && !stopLogs) {
    if (!components[componentName])
      components[componentName] = {
        i: 0,
        color: colors.shift() || `rgb(${cr()},${cr()},${cr()})`,
      };
    components[componentName].i++;
    console.log(`%c render_d ${componentName} ${components[componentName].i}`, `color:white;background:${components[componentName].color};`);
  }
};
